import { useEffect, useState } from "react";
import { ShieldCheck, Clock3 } from "lucide-react";
import { formatTanggal } from "../../lib/tanggal";
import { warrantyState } from "../../lib/warranty";

export default function WarrantyCoverage({ warranty, digital = false }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const update = () => setNow(Date.now());
    const timer = setInterval(update, 30000);
    window.addEventListener("focus", update);
    return () => { clearInterval(timer); window.removeEventListener("focus", update); };
  }, []);
  if (!warranty?.coverage?.length) return null;
  return <div className={digital ? "invoice-coverage-grid" : "space-y-2 mb-3"} data-testid="invoice-warranty-coverage">
    {warranty.coverage.map((row, index) => {
      const state = warrantyState(row, now);
      return <article key={row.id ?? index} className={digital ? `invoice-coverage is-${state.status}` : "border border-slate-200 rounded-lg p-2"}
        data-testid={`warranty-coverage-${row.id ?? index}`}>
        <div className={digital ? "invoice-section-heading" : "flex justify-between gap-2"}>
          <span className={digital ? "invoice-category" : "font-semibold"}>{digital && <ShieldCheck size={15} />} {row.title}</span>
          <span className={digital ? `invoice-status is-${state.status}` : "text-[10px]"}>{digital || !(row.duration_days > 0) ? state.label : `${row.duration_days} hari garansi`}</span>
        </div>
        <h4 className={digital ? "invoice-coverage-name" : "font-semibold mt-1"}>{row.item_name}{row.qty > 1 ? ` · ${row.qty} pcs` : ""}</h4>
        {row.imei && <p className={digital ? "invoice-small" : "text-[10px]"}>IMEI / SN: {row.imei}</p>}
        {state.status === "active" && <div className={digital ? "invoice-countdown" : "mt-1 no-print"}>
          {digital && <Clock3 size={18} />}<span><small className="block">Sisa masa garansi</small><strong>{state.countdown}</strong></span>
        </div>}
        {row.duration_days > 0 && row.end_date && <>
          {digital && <div className="invoice-warranty-progress" role="progressbar" aria-label={`Sisa masa garansi ${row.item_name}`}
            aria-valuenow={Math.round(state.remaining)} aria-valuemin={0} aria-valuemax={100}>
            <span style={{ width: `${state.remaining}%` }} />
          </div>}
          <div className={digital ? "invoice-coverage-dates" : "mt-1"}>
            <span className={digital ? undefined : "block"}>Mulai <b>{formatTanggal(row.start_date)}</b></span><span className={digital ? undefined : "block"}>Sampai <b>{formatTanggal(row.end_date)}</b></span>
          </div>
          <p className={digital ? "invoice-small" : "text-[10px]"}>{row.duration_days} hari · berlaku sampai akhir hari (WIB)</p>
        </>}
      </article>;
    })}
  </div>;
}
